import React from 'react';
import useEmblaCarousel from 'embla-carousel-react';
import ClassNames from 'embla-carousel-class-names';
import AttachmentCard from '../../AttachmentCard';
import {
  NextButton,
  PrevButton,
  usePrevNextButtons,
  DotButton,
  useDotButton
} from './CarouselControls';
import { getThumbnailSizeConfig } from '../utils/carouselConfig';
import './CarouselDisplay.scss';

const CarouselDisplay = ({
  attachments,
  editable,
  onDelete,
  onOrderUpdate,
  onEditComplete,
  showInfo,
  thumbnailSize,
  refreshKey,
  onImageClick,
  carouselOptions = {},
  showControls = true,
  showDots = true,
  className = ""
}) => {
  const [emblaRef, emblaApi] = useEmblaCarousel(carouselOptions, [ClassNames()]);

  const { selectedIndex, scrollSnaps, onDotButtonClick } = useDotButton(emblaApi);

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick
  } = usePrevNextButtons(emblaApi);

  const sizeConfig = getThumbnailSizeConfig(thumbnailSize);

  return (
    <div
      className={`carousel ${className}`}
      style={{
        '--slide-height': sizeConfig.height,
        '--slide-spacing': sizeConfig.slideSpacing,
        '--slide-size': sizeConfig.slideSize
      }}
    >
      <div className="carousel__viewport" ref={emblaRef}>
        <div className="carousel__container">
          {attachments.map((attachment, index) => (
            <div className="carousel__slide" key={`${attachment.id}-${refreshKey}`}>
              <AttachmentCard
                attachment={attachment}
                editable={editable}
                onDelete={() => onDelete(attachment.id)}
                onOrderUpdate={(direction) => onOrderUpdate(attachment.id, direction)}
                onEditComplete={onEditComplete}
                showOrderControls={editable && attachments.length > 1}
                canMoveUp={index > 0}
                canMoveDown={index < attachments.length - 1}
                showInfo={showInfo}
                thumbnailSize={thumbnailSize}
                onImageClick={() => onImageClick?.(attachment.id)}
              />
            </div>
          ))}
        </div>
      </div>

      {showControls && attachments.length > 1 && (
        <div className="carousel__controls">

          {showDots && (
            <div className="carousel__dots">
              {scrollSnaps.map((_, index) => (
                <DotButton
                  key={index}
                  onClick={() => onDotButtonClick(index)}
                  className={`carousel__dot${
                    index === selectedIndex ? ' carousel__dot--selected' : ''
                  }`}
                />
              ))}
            </div>
          )}

          <div className="carousel__buttons">
            <PrevButton onClick={onPrevButtonClick} disabled={prevBtnDisabled} />
            <NextButton onClick={onNextButtonClick} disabled={nextBtnDisabled} />
          </div>

        </div>
      )}
    </div>
  );
};

export default CarouselDisplay;